import { GradeLozenge } from "@idwal/idwal-react-components";
import "./AdjustableGrade.css";
import { InputNumber } from "primereact/inputnumber";
import { ProgressSpinner } from 'primereact/progressspinner';

export interface AdjustableGradeProps {
    vesselGradeId?: number;
    name: string;
    originalGrade: number | null;
    adjustedGrade?: number | null;
    adjustable?: boolean;
    onAdjust?: (score: number, vesselGradeId: number) => void;
    mainGrade?: boolean;
    disabled?: boolean;
}

export const AdjustableGrade = (props: AdjustableGradeProps) => {
    if (!props.originalGrade) {
        return null;
    }

    const onGradeChange = (value: number) => {
        if (props.onAdjust) {
            props.onAdjust(value, props.vesselGradeId ?? 0);
        }
    }
    
    return (
        <div className={`flex align-items-center justify-content-between adjustable-grade ${props.adjustable ? "adjustable-grade-static" : "adjustable-grade-dynamic"}`}>
            <div className="pr-3">
                <span className={`grade-name ${props.mainGrade ? "font-semibold" : ""}`}>{props.name}</span>
            </div>
            <div className="flex align-items-center">
                <GradeLozenge grade={props.originalGrade}></GradeLozenge>
                <div className="ml-4" style={{width: '140px'}}>
                    {props.disabled ?
                        <ProgressSpinner style={{width: '10px', height: '10px'}} />
                    : props.adjustable === false ? (
                            <GradeLozenge grade={props.adjustedGrade ?? props.originalGrade}></GradeLozenge>
                        ) : (
                            <InputNumber 
                                showButtons
                                min={10}
                                max={100}
                                step={10}
                                value={props.adjustedGrade ?? props.originalGrade}
                                onValueChange={(e) => onGradeChange(e.value as number)}
                            />
                        )
                    }
                </div>
            </div>
        </div>
    )
}